import styled from 'styled-components';

export const MediaColumn = styled.div`
  width: 100%;
  /* The modal centres text; labels inside the card read left. */
  text-align: left;

  input[type='file'] {
    display: none;
  }
`;

export const MediaKindRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
`;

/** Grey, under the picker: information, never a blocker. */
export const MediaNote = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.lightGray};
`;
